import {CAMPAIGN_CATEGORY} from '../actions/const';

const evoucherSortColumnOptions = [
  {
      label: "Title",
      value: "title"
  },
  {
      label: "Requried Earning Amount",
      value: "requried_earning_amount"
  },
  {
      label: "Campaign Start Date",
      value: "campaign_start_date"
  }
];

const evoucherSortingOptions = [
  {
      label: "Ascending",
      value: "asc"
  },
  {
      label: "Descending",
      value: "des"
  }
];

const initialState = {
    resetState: false,
    showModal: false,
    isLoadingAction: false,

    selectedData: null,
    formType: "",
    formTitle: "",
    formId: "",

    image: null,
    bannerImage: null,
    title: "",
    descriptions: "",
    earningPeriod: null,
    earningPeriodStartDate: "",
    earningPeriodEndDate: "",
    campaignStartDate: "",
    campaignEndDate: "",
    evoucherSortColumn: evoucherSortColumnOptions[0],
    evoucherSortColumnOptions,
    evoucherSorting: evoucherSortingOptions[0],
    evoucherSortingOptions,

    availabilityStartTime: "",
    availabilityEndTime: ""
};

function reducer (state = initialState, action) {
    let { type, payload } = action;
  
    switch (type) {
      case CAMPAIGN_CATEGORY:
        if (typeof action.payload.resetState !== "undefined" && action.payload.resetState) {
          action.payload = {...initialState};
        }
        return Object.assign({}, state, action.payload);
        break;
  
      default:
        {
          return state;
        }
    }
  }
  
  module.exports = reducer;


// WEBPACK FOOTER //
// ./reducers/CampaignCategory.js